require('./dist/angular-storage.js');
module.exports = 'angular-storage';




//////////////////
// WEBPACK FOOTER
// ./~/angular-storage/index.js
// module id = 378
// module chunks = 1